module.exports = __webpack_public_path__ + "static/media/Barbara.6c009f06.png";